import { z } from "zod"
import { MessageFormatEnum, MessageRoleEnum } from "../conversations/response_data"

export const AmphoraTicketMessageKindEnum = {
  Inbound: "Inbound",
  Outbound: "Outbound",
} as const

export const AmphoraTicketMessageResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  kind: z.enum(AmphoraTicketMessageKindEnum),
  role: z.enum(MessageRoleEnum).nullable(),
  agent: z.string().nullable(),
  originalMessage: z.string().nullable(),
  enhancedMessage: z.string().nullable(),
  mediaUrl: z.string().nullable(),
  mediaFormat: z.enum(MessageFormatEnum).nullable(),
  sentAt: z
    .date()
    .transform((d) => d.toISOString())
    .nullable(),
  createdAt: z.date().transform((d) => d.toISOString()),
})

export const SupportAmphoraTicketMessagesResponseDataSchema = z.object({
  messages: z.array(AmphoraTicketMessageResponseDataSchema),
})

export const AmphoraApiTicketMessageResponseDataSchema = z.object({
  message: z.string().nullish(),
  user: z.string().nullish(),
  date: z.string().nullish(),
  side: z.string().nullish(),
  type: z.string().nullish(),
  source: z.string().nullish(),
  posted_via: z.string().nullish(),
  is_file: z.boolean().nullish(),
  attached_files: z.array(z.json()).nullish(),
  hide: z.boolean().nullish(),
})

export const AmphoraApiTicketResponseDataSchema = z.object({
  company_id: z.string().nullish(),
  gap: z.string().nullish(),
  order_name: z.string().nullish(),
  subcategory: z.string().nullish(),
  source: z.string().nullish(),
  priority: z.string().nullish(),
  client_assigned: z.string().nullish(),
  last_message_date: z.string().nullish(),
  update_time: z.string().nullish(),
  external_id: z.string().nullish(),
  messages: z.array(AmphoraApiTicketMessageResponseDataSchema),
  amphora_assigned: z.string().nullish(),
  started_by: z.string().nullish(),
  read_by: z.json().optional(),
  escalated_at: z.string().nullish(),
  escalated_to: z.string().nullish(),
  escalated_by: z.string().nullish(),
  escalation_reason: z.string().nullish(),
  zendesk_id: z.string().nullish(),
  all_zendesk_id: z.json().optional(),
  external_integration: z.string().nullish(),
  last_external_pointer: z.string().nullish(),
  folder_name: z.string().nullish(),
  folder_date: z.string().nullish(),
})

export const SupportAmphoraTicketResponseDataSchema = z.object({
  externalId: z.string(),
  tickets: z.array(AmphoraApiTicketResponseDataSchema),
})
